'use es6';

/**
 * Returns the first argument it receives.
 */
export default function identityFunc(x) {
  return x;
}